import Loading from "../../../components/Loading"
import ProjectGrid from "../../../components/ProjectGrid"

const OfficeListComponent = ({ OfficeList }: any): JSX.Element => (
  <div className="pt-5 pb-5">
    {OfficeList?.length > 0 ? (
      <>
        <h2 className="fs-1 fw-bolder text-uppercase">Key Office Building Projects</h2>
        <p className="w-50 fs-4">
          We offer a wide range of properties that suit every need from government and private companies, big or small, local or international.
        </p>
        <ProjectGrid
          object={OfficeList}
          link="/find-a-property/search?type=Office+Spaces"
          linkText="VIEW OTHER OFFICE SPACES"
        />
      </>
    ) : (
      <Loading />
    )}
  </div>
);

export default OfficeListComponent;